module.exports = __webpack_public_path__ + "static/media/XVIIe.54c3d11a.gif";